import React from "react";

import "./ResetPassword.styles.scss";
import { useUrlHooks } from "../../hooks";
import { EmailForm } from "./EmailForm";
import { PasswordForm } from "./PasswordForm";

export const ResetPassword: React.FC = () => {
  const {
    queryParams: { token, email },
  } = useUrlHooks();

  return (
    <div className="page reset-password sign-up-page">
      <div className="begin-page__image-wrapper"></div>
      <main className="reset-password__content">
        <span className="reset-password__title">Reset Password</span>
        {token && email ? (
          <PasswordForm token={token} email={email} />
        ) : (
          <EmailForm />
        )}
      </main>
    </div>
  );
};
